import moment from 'moment';
import { CONSOLE_PLATFORM_PLAYSTATION } from '@/pages/intelligence/_config/storeRank/config';
import { AREAS_MAPPING } from '@/pages/intelligence/components/TeaSelector/AreaSelect/constants';

import type { IDateTypely } from '@/pages/intelligence/types/common';
import type { IConsoleStoreRankPlatform } from '@/pages/intelligence/types/storeRank';

interface IGetInitialHelperCfg {
  start_date: string;
  end_date: string;
  regions: string[];
  [key: string]: any;
}

export const getInitialDate = (
  isMonthlyRank: boolean,
  cfg: {
    extendStartDate?: string;
    extendEndDate?: string;
    defaultFilter: IGetInitialHelperCfg;
  },
): string => {
  const { extendStartDate, extendEndDate, defaultFilter } = cfg || {};
  const date = extendStartDate || extendEndDate || defaultFilter?.start_date || defaultFilter?.end_date;
  if (!date) return '';
  if (!isMonthlyRank) return date;
  const m = moment(date);
  if (!m.isValid()) return '';
  return moment(date).startOf('month').format('YYYY-MM-DD');
};

const getInitialCountries = (extendValue: any, defaultFilter: IGetInitialHelperCfg): string[] => {
  const countries = extendValue?.countries;
  return countries?.length >= 1 ? countries : defaultFilter?.regions;
};

const getInitialAreas = (extendValue: string): string[] =>
  extendValue ? [extendValue] : [AREAS_MAPPING.NORTH_AMERICA];

export const getInitialRegions = (
  isMonthlyRank: boolean,
  cfg: {
    composedCountryExtend: any;
    singleAreaExtend: string;
    defaultFilter: IGetInitialHelperCfg;
  },
): string[] => {
  const { composedCountryExtend, singleAreaExtend, defaultFilter } = cfg || {};
  if (isMonthlyRank) return getInitialAreas(singleAreaExtend);
  return getInitialCountries(composedCountryExtend, defaultFilter);
};

export const getIsMonthlyRank = (platform: IConsoleStoreRankPlatform, granularity?: IDateTypely): boolean => {
  const flag1 = platform === CONSOLE_PLATFORM_PLAYSTATION;
  const flag2 = granularity === 'monthly';
  return flag1 && flag2;
};
